import { useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { QrCode, Download, Printer } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";
import { Card, Btn } from "@/components/ui-kit";

export function MenuQrCard() {
  const { restaurant, setRestaurant } = useAuth();
  const { t } = useT();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const url = `${window.location.origin}/menu/${restaurant.slug}`;
  const png = () => ref.current?.querySelector("canvas")?.toDataURL("image/png");
  const download = () => { const a = document.createElement("a"); a.href = png(); a.download = `qr_menu_${restaurant.slug}.png`; a.click(); };
  const printPdf = async (tables) => {
    setBusy(true);
    try {
      const res = await api.get(`/restaurants/${restaurant.id}/menu-qr.pdf`, { params: { origin: window.location.origin, tables: tables ? 1 : 0 }, responseType: "blob" });
      const u = URL.createObjectURL(res.data); const a = document.createElement("a"); a.href = u; a.download = tables ? `qr_tavoli_${restaurant.slug}.pdf` : `qr_menu_${restaurant.slug}.pdf`; a.click(); URL.revokeObjectURL(u);
    } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  const toggleOrdering = async (on) => { try { await api.patch(`/restaurants/${restaurant.id}/qr-ordering`, { enabled: on }); setRestaurant({ ...restaurant, qr_ordering: on }); toast.success(t("saved")); } catch (ex) { toast.error(errMsg(ex)); } };
  return (
    <Card data-testid="menu-qr-card">
      <p className="flex items-center gap-2 font-heading font-bold"><QrCode size={18} className="text-[#4a8a56]" />{t("menu_qr")}</p>
      <p className="mt-1 text-sm text-slate-600">{t("menu_qr_desc")}</p>
      <div className="mt-4 flex flex-wrap items-center gap-5">
        <div ref={ref} className="rounded-2xl border border-slate-200 bg-white p-3"><QRCodeCanvas value={url} size={160} level="M" /></div>
        <div className="min-w-0 flex-1 space-y-2">
          <a data-testid="menu-qr-link" href={url} target="_blank" rel="noreferrer" className="block truncate rounded-xl bg-[#f6faf6] px-3 py-2 font-mono text-xs text-[#4a8a56] underline">{url}</a>
          <div className="flex flex-wrap gap-2">
            <Btn data-testid="menu-qr-download" variant="outline" onClick={download}><Download size={16} />PNG</Btn>
            <Btn data-testid="menu-qr-pdf" disabled={busy} onClick={() => printPdf(false)}><Printer size={16} />{t("menu_qr_pdf")}</Btn>
            <Btn data-testid="tables-qr-pdf" variant="outline" disabled={busy} onClick={() => printPdf(true)}><Printer size={16} />{t("tables_qr_pdf")}</Btn>
          </div>
          <p className="text-xs text-slate-500">{t("menu_qr_hint")}</p>
          <p className="text-xs text-slate-500">{t("tables_qr_hint")}</p>
          <label className="flex items-center gap-2 text-sm font-semibold"><input data-testid="qr-ordering-toggle" type="checkbox" className="h-4 w-4 accent-[#5aa469]" checked={restaurant.qr_ordering !== false} onChange={(e) => toggleOrdering(e.target.checked)} />{t("qr_ordering_enabled")}</label>
        </div>
      </div>
    </Card>
  );
}
